import { Injectable } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { Router } from '@angular/router';
import { DataService } from './data.service';
import { ILoginRequest } from '@core/interfaces/ilogin-request';
import { ILoginResponse } from '@core/interfaces/ilogin-response';
import { environment } from '@env/environment';
import { JwtHelperService } from '@auth0/angular-jwt';
import { IRequestAccount } from '@core/interfaces/irequest-account';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private readonly bearerToken = environment.bearerToken;
  private readonly adminInfo = 'cahcc-admin';
  private jwtHelper = new JwtHelperService();
  constructor(
    public data: DataService,
    private router: Router,
    private toast: ToastrService
  ) {}

  login(user: ILoginRequest, message?: string): Observable<any> {
    return this.data.post('auth/admin-login', user, message).pipe(
      tap((res: ILoginResponse) => {
        if (res.bearerToken) {
          this.captureUserInfo(res);
          this.router.navigateByUrl('/admin');
        }
      })
    );
  }

  forgotPassword(email: string, message?: string): Observable<any> {
    return this.data.post(`auth/forgot-password?email=${email}`, null, message);
  }

  resetPassword(request: any, message?: string): Observable<any> {
    return this.data.put('auth/save-password', request, message);
  }

  createPassword(request: any, message?: string): Observable<any> {
    return this.data.put(`auth/save-password`, request, message);
  }

  changePassword(password: any, message?: string): Observable<any> {
    return this.data.put(`auth/change-password`, { password }, message);
  }

  isValidIdentifier(guid: string) {
    return this.data.get(`auth/is-valid-identifier/${guid}`);
  }

  captureUserInfo(loginRes: ILoginResponse): void {
    localStorage.setItem(
      this.bearerToken,
      JSON.stringify(loginRes.bearerToken)
    );
    localStorage.setItem(this.adminInfo, JSON.stringify(loginRes));
  }

  isLoggedIn(): boolean {
    let isLoggedIn = false;
    const token = localStorage.getItem(this.bearerToken);
    if (token) {
      isLoggedIn = !this.jwtHelper.isTokenExpired(token);
    }

    return isLoggedIn;
  }

  logout(): void {
    localStorage.clear();
    this.toast.success('Logged out successfully. See you next time!');
    this.router.navigateByUrl('/');
  }

  getCurrentUser() {
    const user = JSON.parse(localStorage.getItem(this.adminInfo) ?? '{}');
    return user;
  }

  isDuplicateEmail(email: string, message?: string): Observable<boolean> {
    return this.data.get(`auth/duplicateEmail/${email}`, message);
  }
}
